export default {
  dsimLogin: {
    title: 'Account login',
    userName: 'User name',
    password: 'Password',
    log: 'Login',
    resiger: 'Sign up',
    ruleEmail: 'Please enter the user name',
    rulePwd: 'Please enter the password',
    logSucess: 'Login successfully',
    companyAccount: 'User name',
    logPwdError: 'Wrong account or password, please re-enter',
    noResiger: 'This account is not registered and cannot log in temporarily'
  },
  dsimResiger: {
    title: 'DSIM Account registration',
    userName: 'User account',
    telephone: 'Telephone',
    companyName: 'Company name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgetPwd: 'Forget password',
    log: 'Confirm',
    ruleUserName: 'Please enter the user account',
    ruleTelephone: 'Please enter a telephone number',
    ruleCompanyName: 'Please enter the Company name',
    rulePwd: 'Please enter the password',
    confirmAgainPassWord: 'Please enter the password again',
    noTwoPassWord: 'The two passwords are inconsistent, please re-enter',
    ruleEmail: 'Please enter the email address',
    ruleTrueEmail: 'Please enter a correct email address',
    resigerSuccess: 'Registration successful',
  },
  licenseManager: {
    selectFont: 'Please select',
    manageTitle: 'Manage',
    userNameSearch: 'Search by name',
    emailSearch: 'Search by email',
    companySearch: 'Search by company name',
    licenseIdSearch: 'Search by licenseId',
    typeSearch: 'Search by type',
    groupSearch: 'Search by user group',
    userName: 'User account',
    telephone: 'Telephone',
    licenseStartTime: 'Start Date',
    licenseEndTime: 'Expiry Date',
    companyAccount: 'Company account',
    companyName: 'Company name',
    email: 'Email address',
    licenseTypeName: 'License type',
    userGroupName: 'User group',
    operation: 'Operation',
    downLoad: 'Download the license file',
    add: 'Add',
    manger: 'Manage',
    modify: 'Modify',
    delete: 'Delete',
    show: 'Login activities',
    showActive: 'Online population'
  },
  licenseShow: {
    userName: 'User account',
    loginTime: 'Login time',
    logoutTime: 'Logout time',
    userShowList: 'User activities'
  },
  licenseUserShow: {
    userName: 'Account'
  },
  lincenceAdd: {
    versionInfo: 'Version information',
    ruleVersionInfo: 'Please enter the version information, for example: 1.00、2.10、3.43',
    userName: 'User account',
    telephone: 'Telephone',
    companyName: 'Company name',
    email: 'Email',
    password: 'Password',
    machineCode: 'Computer ID',
    licenseType: 'License type',
    userGroup: 'User group',
    licenseStartTime: 'Start date',
    licenseEndTime: 'Expiry date',
    licenceEffectiveTime: 'Valid period',
    licenceMaintenancePeriod: 'Maintenance period',
    companyAccount: 'Enterprise account',
    userCount: 'Maximum number of online computers',
    serverAddress: 'Server address',
    moreCode: 'Please separate them with commas',
    codeTipOne: 'Only one Computer ID can be entered',
    codeTipTwo: 'A maximum of two Computer IDs can be entered',
    save: 'Save',
    close: 'Close',
    ruleUserName: 'Please enter the user account',
    ruleTelephone: 'Please enter the telephone',
    ruleCompanyName: 'Please enter the company name',
    ruleEmail: 'Please enter the email address',
    rulePwd: 'Please enter the password',
    ruleMachineCode: 'Please enter the Computer ID',
    ruleLicenseType: 'Please select the license type',
    ruleUserGroup: 'Please select the user group',
    ruleLicenseStartTime: 'Please select the start date',
    ruleLicenseEndTime: 'Please select the expiry date',
    ruleLicenceEffectiveTime: 'Please enter the valid period',
    ruleLicenceMaintenancePeriod: 'Please enter the maintenance period',
    ruleCompanyAccount: 'Please enter the enterprise account',
    ruleLicenceUserCount: 'Please enter the maximum number of online computers',
    ruleServiceAddress: 'Please enter the server IP address',
    ruleTrueServiceAddress: 'Please enter a correct IP address',
    licenseType1: 'Community',
    licenseType2: 'Standalone(offline)',
    licenseType3: 'Network(WAN)',
    licenseType4: 'Network(LAN)',
    licenseType5: 'Hardware Standalone',
    licenseType6: 'Hardware Network',
    licenseType7: 'Standalone',
    group1: 'Community users',
    group2: 'Trial users',
    group3: 'Lite users',
    group4: 'Pro users',
    group5: 'Enterprise users',
    group6: 'Developers',
    addTitle: 'Add account',
    modifyTitle: 'Modify account'
  },
  companyLogin: {
    title: 'Enterprise administrator login',
    companyAccount: 'Enterprise account',
    password: 'Password',
    log: 'Login',
    ruleCompanyAccount: 'Please enter the enterprise account',
    rulePwd: 'Please enter the password'
  },
  companyUserInfo: {
    userAccount: 'Account',
    password: 'Password',
    userName: 'User account',
    userDesc: 'User description',
    machineCode: 'Computer ID',
    licenseTypeName: 'License type',
    userGroupName: 'User group',
    loginTime: 'Login time',
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    refresh: 'Refresh',
    ruleUserAccount: 'Please enter the user account',
    ruleUserName: 'Please enter the user name',
    rulePwd: 'Please enter the password',
    ruleCode: 'Please enter the Computer ID',
    addAccount: 'Add account',
    modifyAccount: 'Modify account'
  },
  commentData: {
    selectFont: 'Please select',
    selectDate: 'Please select a date',
    selectDeleteData: 'Please select the data to delete',
    selectModifyData: 'Please select the data to modify',
    addSucess: 'Successfully added',
    modifySucess: 'Successfully modified',
    addFail: 'Fail to add',
    modifyFail: 'Fail to modify',
    noLoginTip: 'Please login first',
    noModify: 'Community version cannot be modified temporarily',
    noData: 'No data available',
    loginSuccess: 'Login successfully',
    modifySuccess: 'Modification succeeded, please login again',
    noAddInfo: 'The number of computers exceeds the limit. No more computers can be added',
    reset: 'Reset',
    resigerSuccess: 'Registration successful',
    type7DeleteData: 'Activated computers cannot be deleted',
    type7EditeData: 'Activated computers cannot be modified'
  },
  navbar: {
    logOut: 'Log out',
    pageTitle: 'DSIM license management system'
  },
  route: {
    accountManager: 'License management',
    personInfo: 'Personal center',
    fileUpload: 'Version management'
  },
  personInfo: {
    modifyPwd: 'Change Password',
    nowPassWord: 'Current password',
    newPassWord: 'New password',
    confirmPassWord: 'Confirm password',
    nowRulePassWord: 'Please enter the current password',
    newRulePassWord: 'Please enter the new password',
    confirmRulePassWord: 'Please confirm the password',
    nowErrorPassWord: 'The current password is incorrect',
    confirmAgainPassWord: 'Please enter the password again',
    noTwoPassWord: 'The two passwords are inconsistent, please re-enter',
    userCode: 'Email verification code',
    sendUserCode: 'Send email verification code',
    newRuleUserCode: 'Please enter the email verification code'
  },
  deleteObj: {
    title: 'Are you sure to delete it?',
    tip: 'Tips',
    confirm: 'Comfirm',
    quit: 'Cancel',
    success: 'Successfully deleted',
    fail: 'Fail to delete'
  },
  dsimDeleteOnj: {
    title: 'When deleting the enterprise account, the sub-accounts will also be deleted. Are you sure to delete it?',
    titleTwo: 'Are you sure to delete it?'
  },
  modifyObj: {
    title: 'Are you sure to modify?',
    tip: 'Tips',
    confirm: 'Comfirm',
    quit: 'Cancel',
    success: 'Successfully modified',
    fail: 'Modification failed'
  },
  addObj: {
    title: 'Are you sure to add?',
    tip: 'Tips',
    confirm: 'Comfirm',
    quit: 'Cancel',
    success: 'Successfully added',
    fail: 'Failed to add'
  },
  logoutObj: {
    title: 'Are you sure to log out?',
    tip: 'Tips',
    confirm: 'Comfirm',
    quit: 'Cancel'
  },
  version: {
    title: 'Version management',
    tip: 'Drag files here to upload or',
    number: 'Version number',
    selectFile: 'Select file',
    selectFolder: 'Select folder',
    success: 'Succeed',
    error: 'Error',
    uploading: 'Uploading',
    paused: 'Suspended',
    waiting: 'Waiting',
    uploadSucess: 'Upload successfully',
    uploadFail: 'Upload failed'
  },
  enterpriseManager: {
    company: 'Company',
    code: 'License ID',
    total: 'Maximum number of online computers',
    onlineTotal: 'Maximum number of online computers',
    coded: 'Number of currently online computers',
    onlineCoded: 'Number of currently online computers',
    searchName: 'Search by name',
    num: 'Serial No'
  },
  enterpriseManagerAdd: {
    addTitle: 'Add user account',
    modifyTitle: 'Modify user account',
    number: 'Serial number',
    info: 'User account',
    status: 'Status',
    valid: 'Valid',
    invalid: 'Invalid',
    password: 'Password',
    total: 'Maximum number of online computers',
    totaled: 'Number of currently online computers',
    period: 'License period',
    day: 'Day',
    setExpiry: 'Set the expiry date based on license period and the date of next activation',
    absoluteDate: 'Absolute expiry date',
    computerList: 'Computer list',
    activities: 'Show activities',
    ruleInfo: 'Please enter the user account',
    rulePassword: 'Please enter the password',
    ruleTotal: 'Please enter the maximum number of online computers',
    ruleTotaled: 'Please enter the number of currently online computers',
    automaticLogonSetting: 'Automatic Registration Settings',
    automaticLogon: 'Automatic registration',
    userDesc: 'User description',
    autoRegisterNum: 'Number of automatic registrations'
  },
  computerObj: {
    number: 'Serial No',
    user: 'User',
    des: 'Description',
    computerId: 'Computer ID',
    activeDate: 'Activation date',
    expiryDate: 'Expiry date',
    loginTime: 'Login time',
    logoutTime: 'Logout time',
    machineCode: 'Computer ID',
    computerDes: 'Computer description',
    ruleMachineCode: 'Please enter the Computer ID',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close'
  },
  resetPwd: {
    title: 'DSIM Password Reset',
    stepOne: 'Email verification',
    stepTwo: 'Password Reset',
    stepThree: 'Reset completed',
    nextStep: 'Next step',
    resetSucess: 'Password reset succeeded'
  },
  emailActive: {
    title: 'Thanks for registration! An activation email has been sent to your registered email',
    '30min': 'Please check your email within 30 minutes to complete the activation',
    tips: 'Did not receive an email?',
    tip1: 'Please check whether the email address is correct, you can return and',
    fillAgain: 'fill again',
    tip2: 'Please check the spam folder in your email',
    tip3: 'If you still have not received the activation email, try',
    sendAgain: 'sending it again',
    sendSuccess: 'Send successfully',
    goBack: 'Go back',
    goEmail: 'Go to the email'
  },
  registerSuccess: {
    goBack: 'Go back',
    title: 'Congratulations, registration successful!',
    nowuse: 'Welcome to use DSIM license management system'
  },
  versionManager: {
    version: 'Version',
    publishFlag: 'Publish status',
    publishTime: 'Publish time',
    uploadTime: 'Upload time',
    operation: 'Operation',
    manger: 'Manage',
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    refresh: 'Refresh',
    ruleVersion: 'Please enter the version number',
    addTitle: 'Add version',
    modifyTitle: 'Modify version',
    publish: 'Publish',
    unPublish: 'Unpublish',
  },
  errorCode: {
    '401': 'Authentication failed, unable to access system resources',
    '403': 'No permissions for the current operation',
    '404': '404 not found',
    'default': 'Unknow error. Please report the error to the administrator',
    '401tips': 'The login status has expired. Stay on the page or login again',
    '401title': 'System prompt',
    relogin: 'Re-login',
    stay: 'Stay',
    networkError: 'Backend interface connection error',
    timeout: 'System interface request timed out',
    requestFailed1: 'System interface',
    requestFailed2: 'error',
    companyIsResiger:'This account has been registered, please change another account',
    emailIsResiger:'This email has been registered, please change another email',
    infoIsNull:'Failed to obtain the login user. Please log in again or contact the administrator',
    noPermission:'The login user has no permission. Please contact the administrator',
    oldPasswordIsWrong:'The old password is not correct',
    emailSendError:'Activation email sending failed. Please try again later',
    userCodeWrong:'Verification code error',
    userCodeInForce:'Verification code has not expired',
    repetActice:'Already in an activated state, no need to activate again',
    userCodeExpriy:'Activation times out, and the verification code is sent again',
    getLicenseError:'Unexpected license information. Please contact the administrator',
    operationFailed:'Operation failure',
    machineCodeIsSame:'The same machine already exists in this account',
    companyUnResiger:'This account is not registered, please re-enter',
    accountOrPasswordWrong:'Incorrect account or password, please enter again',
    accountOutOfDate:'This account is not within the valid period and login is not allowed. Please contact the administrator.',
    userNameIsSame:'The account has a user with the same name. Please change the name',
    haveSubusers: 'This account has a sub-account and cannot be deleted. Please delete the sub-account first',
    haveComputer: 'This account has a computer, cannot be deleted, please delete the computer first',
    computerIsActive: 'An active computer cannot be deleted'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js